import { AuthService } from './services/auth.service';
import { inject } from '@angular/core';
import { CanActivateFn,Router } from '@angular/router';



export const AdminGuard: CanActivateFn = (route, state) => {
    const routers=inject(Router);
    const service=inject(AuthService);
  
    const user = service.getCurrentUser();
    const loginuser=JSON.parse(localStorage.getItem('loggedInUser') || '{}'); 
    
    if (user && user.username === loginuser.username) {
      return true;
    } else {
      routers.navigate(['home']);
      return false;
    }
  };
  